<template>
  <v-autocomplete
    v-model="vModel"
    :items="users"
    :search-input.sync="search"
    item-value="id"
    item-text="profile.displayName"
    :label="label"
    :solo="solo"
    clearable
    hide-details
    no-data-text="No users found"
  >
    <template v-slot:selection="{ item }">
      <div class="user-picker__selection">
        <pa-user-avatar
          :image="item.profile.photoURL"
          :name="item.profile.displayName"
          type="avatar"
          :size="26"
        />
        {{ item.profile.displayName }}
      </div>
    </template>

    <template v-slot:item="{ item }">
      <pa-user-avatar
        :image="item.profile.photoURL"
        :name="item.profile.displayName"
      />

      <v-list-item-content>
        <v-list-item-title>
          {{ item.profile.displayName || item.email }}
        </v-list-item-title>

        <v-list-item-subtitle>
          {{ item.profile.jobTitle }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    label: {
      type: String,
      default: 'User'
    },
    solo: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      search: null
    }
  },
  computed: {
    ...mapState([ 'users' ]),
    vModel: {
      get () { return this.value },
      set (val) {
        if (val) {
          this.$emit('input', val)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.user-picker {
  &__selection {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
